import { useCachedApiCall } from '@hooks/apiCall';
import { shiftTypesCache } from './shiftTypeStore';

/*
 * Thin cache-backed bindings so hooks and features don't hand-roll
 * param arrays. See docs/api-caching.md §8 for the hook contract.
 */

/** Cache-backed shift types of a department. */
export const useShiftTypesEntry = (departmentId?: string) =>
    useCachedApiCall(shiftTypesCache, [departmentId]);
